(() => {
  'use strict';
  const search = document.querySelector('.header-search');
  const field = search?.querySelector('[name="q"]');
  const results = search?.querySelector('#PredictiveResults');
  if (field && results) {
    let timer;
    let request;
    let selected = -1;
    const options = () => [...results.querySelectorAll('[role="option"]')];
    const close = () => { results.hidden = true; field.setAttribute('aria-expanded', 'false'); field.removeAttribute('aria-activedescendant'); selected = -1; options().forEach(link => link.setAttribute('aria-selected','false')); };
    field.addEventListener('input', () => {
      clearTimeout(timer);
      request?.abort();
      close();
      const term = field.value.trim();
      if (term.length < 2) return;
      timer = setTimeout(async () => {
        request = new AbortController();
        const activeRequest = request;
        const url = new URL(search.dataset.predictiveUrl, location.origin);
        url.search = new URLSearchParams({ q: term, section_id: 'predictive-search', 'resources[type]': 'product', 'resources[limit]': '5' });
        try {
          const response = await fetch(url, { signal: activeRequest.signal });
          if (!response.ok) return;
          const html = await response.text();
          if (activeRequest.signal.aborted || field.value.trim() !== term) return;
          const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive-content]');
          if (!content) return;
          content.querySelectorAll('ul,li').forEach(item => item.setAttribute('role','presentation'));
          content.querySelectorAll('a').forEach((link,index) => { link.id = 'PredictiveOption-' + index; link.setAttribute('role','option'); link.setAttribute('tabindex','-1'); link.setAttribute('aria-selected','false'); });
          results.replaceChildren(content);
          results.hidden = false;
          field.setAttribute('aria-expanded', 'true');
        } catch { if (request === activeRequest && !activeRequest.signal.aborted) close(); }
      }, 200);
    });
    search.addEventListener('keydown', event => {
      if (event.key === 'Escape') { request?.abort(); clearTimeout(timer); close(); field.focus(); }
      if (results.hidden) return;
      const links = options();
      if (event.key === 'Enter' && selected >= 0) { event.preventDefault(); location.assign(links[selected].href); return; }
      if (!links.length || !['ArrowDown','ArrowUp'].includes(event.key)) return;
      event.preventDefault();
      selected = event.key === 'ArrowDown' ? (selected + 1) % links.length : selected < 0 ? links.length - 1 : (selected - 1 + links.length) % links.length;
      links.forEach((link,index) => link.setAttribute('aria-selected',String(index === selected)));
      field.setAttribute('aria-activedescendant',links[selected].id);
      links[selected].scrollIntoView?.({block:'nearest'});
      field.focus();
    });
    const dismiss = () => { request?.abort(); clearTimeout(timer); close(); };
    search.addEventListener('focusout', event => { if (!search.contains(event.relatedTarget)) dismiss(); });
    document.addEventListener('click', event => { if (!search.contains(event.target)) dismiss(); });
  }
  document.querySelectorAll('[data-recommendations]').forEach(async section => {
    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) return;
      const content = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-recommendations]');
      if (content?.querySelector('.product-grid')) { section.replaceChildren(...content.childNodes); document.dispatchEvent(new Event('makishop:products-loaded')); }
      else section.hidden = true;
    } catch { section.hidden = true; }
  });
  const current = document.querySelector('[data-recent-current]');
  const recentSection = document.querySelector('[data-recent-products]');
  if (current && recentSection) {
    try {
      const key = 'makishop-recent-products-v1';
      const raw = JSON.parse(localStorage.getItem(key) || '[]');
      const safe = Array.isArray(raw) ? raw.filter(item => item && /^\d+$/.test(String(item.id)) && typeof item.title === 'string' && typeof item.url === 'string' && /^\/products\/[^/]+/.test(item.url)).slice(0, 8) : [];
      const recent = safe.filter(item => item.id !== current.dataset.productId);
      const list = recentSection.querySelector('ul');
      recent.slice(0,4).forEach(item => { const li = document.createElement('li'); const a = document.createElement('a'); a.href = item.url; a.textContent = item.title; li.append(a); list.append(li); });
      recentSection.hidden = recent.length === 0;
      localStorage.setItem(key, JSON.stringify([{id:current.dataset.productId,title:current.dataset.productTitle,url:current.dataset.productUrl},...recent].slice(0,8)));
    } catch { recentSection.hidden = true; }
  }
  document.querySelector('[data-gift-print]')?.addEventListener('click', () => window.print());
  const sticky = document.querySelector('[data-sticky-product]');
  const productForm = document.querySelector('[data-product-section] form[action*="/cart/add"]');
  if (sticky && productForm && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting || productForm.getBoundingClientRect().top > 0; }).observe(productForm);
    sticky.addEventListener('click', event => { event.preventDefault(); productForm.scrollIntoView({ block: 'center', behavior: 'instant' }); productForm.querySelector('button')?.focus({ preventScroll: true }); });
  }
})();
